import Cookies from 'universal-cookie'
import qs from 'query-string'

import createConstant from '../../utils/createConst'
import { API_HOSTNAME } from '../../GlobalConfig'

const cookie = new Cookies()
const token = cookie.get('TKN_MINAPOLI')

const DETAIL = createConstant('shop/DETAIL')
const PROMOTED = createConstant('shop/PROMOTED')
const SHOP_PASAR = createConstant('shop/SHOP_PASAR')
const SHOP_EVENT = createConstant('shop/SHOP_EVENT')
const SHOP_INFO = createConstant('shop/SHOP_INFO')
const SEND_MESSAGE = createConstant('shop/SEND_MESSAGE')

const initialState = {
  shopRequest: false,
  shopError: '',
  shop: undefined,
  promotedRequest: false,
  promotedError: '',
  promoted: undefined,
  pasarRequest: false,
  pasarError: '',
  pasar: undefined,
  pasarTotal: 0,
  pasarPagination: {
    next: undefined,
    prev: undefined,
    current: 1,
    perPage: 12,
  },
  activeCategoryPasar: 0,
  eventRequest: false,
  eventError: '',
  event: undefined,
  eventTotal: 0,
  eventPagination: {
    next: undefined,
    prev: undefined,
    current: 1,
    perPage: 12,
  },
  activeCategoryEvent: 0,
  infoRequest: false,
  infoError: '',
  info: undefined,
  infoTotal: 0,
  infoPagination: {
    next: undefined,
    prev: undefined,
    current: 1,
    perPage: 12,
  },
  activeCategoryInfo: 0,
  sendMessageRequest: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case DETAIL.request:
      return {
        ...state,
        shopRequest: true,
        shopError: '',
      }
    case DETAIL.failed:
      return {
        ...state,
        shopRequest: false,
        shopError: action.error.message,
        shop: undefined,
      }
    case DETAIL.success:
      return {
        ...state,
        shopRequest: false,
        shoplError: '',
        shop: action.result.result,
      }
    case PROMOTED.request:
      return {
        ...state,
        promotedRequest: true,
        promotedError: '',
      }
    case PROMOTED.failed:
      return {
        ...state,
        promotedRequest: false,
        promotedError: action.error.message,
        promoted: undefined,
      }
    case PROMOTED.success:
      return {
        ...state,
        promotedRequest: false,
        promotedError: '',
        promoted: action.result.result,
      }
    case SHOP_PASAR.request:
      return {
        ...state,
        pasarRequest: true,
        pasarError: '',
      }
    case SHOP_PASAR.failed:
      return {
        ...state,
        pasarRequest: false,
        pasarError: action.error.message,
        pasar: undefined,
      }
    case SHOP_PASAR.success:
      return {
        ...state,
        pasarRequest: false,
        pasarError: '',
        pasar: action.result.result,
        pasarTotal: action.result.total,
        pasarPagination: action.result.pagination,
        activeCategoryPasar: action.payload.category,
      }
    case SHOP_EVENT.request:
      return {
        ...state,
        eventRequest: true,
        eventError: '',
      }
    case SHOP_EVENT.failed:
      return {
        ...state,
        eventRequest: false,
        eventError: action.error.message,
        event: undefined,
      }
    case SHOP_EVENT.success:
      return {
        ...state,
        eventRequest: false,
        eventError: '',
        event: action.result.result,
        eventTotal: action.result.total,
        eventPagination: action.result.pagination,
        activeCategoryEvent: action.payload.category,
      }
    case SHOP_INFO.request:
      return {
        ...state,
        infoRequest: true,
        infoError: '',
      }
    case SHOP_INFO.failed:
      return {
        ...state,
        infoRequest: false,
        infoError: action.error.message,
        info: undefined,
      }
    case SHOP_INFO.success:
      return {
        ...state,
        infoRequest: false,
        infoError: '',
        info: action.result.result,
        infoTotal: action.result.total,
        infoPagination: action.result.pagination,
        activeCategoryInfo: action.payload.category,
      }
    case SEND_MESSAGE.request:
      return {
        ...state,
        sendMessageRequest: true,
      }
    case SEND_MESSAGE.failed:
    case SEND_MESSAGE.success:
      return {
        ...state,
        sendMessageRequest: false,
      }
    default:
      return state
  }
}

const options = {
  method: 'GET',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  mode: 'cors',
}

export const getDetail = domain => (dispatch) => {
  dispatch({
    types: DETAIL,
    promise: fetch(`${API_HOSTNAME}/v1/shop/${domain}`, options),
  })
}

export const getPromoted = shopID => (dispatch) => {
  dispatch({
    types: PROMOTED,
    promise: fetch(`${API_HOSTNAME}/v1/shop/${shopID}/product/promoted`, options),
  })
}

export const getShopPasar = (shopID, category, sort, page) => (dispatch) => {
  const qstring = qs.stringify({
    sort,
    page,
  })
  const categoryAppend = category ? `/${category}` : ''
  const url = `${API_HOSTNAME}/v1/shop/${shopID}/product${categoryAppend}?${qstring}`

  dispatch({
    types: SHOP_PASAR,
    payload: { category },
    promise: fetch(url, options),
  })
}

export const getShopEvent = (shopID, category, _sort, _page) => (dispatch) => {
  dispatch({
    types: SHOP_EVENT,
    payload: { category },
    promise: fetch(`${API_HOSTNAME}/v1/shop/${shopID}/event`, options),
  })
}

export const getShopInfo = (shopID, category, _sort, _page) => (dispatch) => {
  dispatch({
    types: SHOP_INFO,
    payload: { category },
    promise: fetch(`${API_HOSTNAME}/v1/shop/${shopID}/article`, options),
  })
}

export const sendMessageRequest = (shopID, message) => (dispatch) => {
  dispatch({
    types: SEND_MESSAGE,
    promise: fetch(`${API_HOSTNAME}/v1/shop/message/${shopID}/send`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({ message }),
    }),
  })
}



// WEBPACK FOOTER //
// ./src/modules/Shop/index.js